// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobListTable .task-field-width {
  width: 350px;
}
.jobListTable .non-task-width {
  width: 200px;
}

.d-n {
  display: none;
}

.version,
.action {
  width: 100%;
  display: block;
  cursor: pointer;
  text-align: center;
}

.owner,
.date {
  width: 100%;
  display: block;
  cursor: default;
}

.download_icon {
  cursor: pointer;
  padding-right: 15px;
}

.view_pdf_icon {
  cursor: pointer;
}

.upload-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.action-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrap-free-text {
  white-space: normal !important;
  word-break: break-word;
}

.nowrap-free-text {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.myProjectAnddAllProjectList.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler {
  width: 0;
  height: 0;
  padding: 7px;
  border-radius: 0%;
  border: 1px solid black;
}

.p-confirm-popup {
  position: absolute;
  top: 12% !important;
  left: 0% !important;
}

.p-datepicker table td {
  padding: 0.2px !important;
}

.p-button:focus {
  box-shadow: none !important;
}

.myProjectAnddAllProjectList {
  height: 100%;
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable {
  height: calc(100% - 90px);
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable > .p-treetable-wrapper {
  height: 100%;
  width: 100%;
}
.myProjectAnddAllProjectList .p-treetable > .p-treetable-wrapper .p-treetable-scrollable-view {
  height: 100%;
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable > .p-treetable-wrapper .p-treetable-scrollable-view .p-treetable-scrollable-body {
  position: relative;
  height: calc(100% - 46px);
}
.myProjectAnddAllProjectList .p-treetable.searchWithTreeTable > .p-treetable-wrapper .p-treetable-scrollable-view .p-treetable-scrollable-body {
  height: calc(100% - 100px);
}
.myProjectAnddAllProjectList .p-datatable > .p-datatable-wrapper {
  overflow: scroll;
  width: 100%;
}
.myProjectAnddAllProjectList .p-datatable-tbody {
  font-weight: 400;
}
.myProjectAnddAllProjectList td,
.myProjectAnddAllProjectList table .p-datatable .p-datatable-tbody > tr > td,
.myProjectAnddAllProjectList th,
.myProjectAnddAllProjectList tr {
  position: relative;
}
.myProjectAnddAllProjectList .input-duration > input {
  max-width: 70px;
  border-radius: 5px;
  text-align: center;
  height: 25px;
}
.myProjectAnddAllProjectList .task-link {
  color: #003da5;
  cursor: pointer;
  line-height: 15px;
  line-break: anywhere;
}
.myProjectAnddAllProjectList table .p-inputtext {
  width: 100% !important;
  font-size: 12px !important;
}
.myProjectAnddAllProjectList table .p-inputtext.p-autocomplete-input {
  padding: 0 5px;
}

.font-bold {
  font-weight: 700;
}

.p-checkbox {
  margin: 8px;
}

.p-checkbox-checked + label {
  color: #003da5;
}

.ml-2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

img[disabled] {
  opacity: 0.5;
  cursor: no-drop;
}

.clearAllFilterMainDiv {
  display: flex;
  padding: 10.56px 22px 22px 2px;
}

.clearAllFilterDiv {
  line-height: 12px;
  justify-items: end;
  display: flex;
  position: absolute;
  right: 22px;
  top: 18px;
}

.clearAllFilter {
  cursor: pointer;
}

.clearAllFilterIcon {
  cursor: pointer;
  position: absolute;
  right: 5px;
}

.sortAndFrozen {
  padding: 0 22px 22px 2px;
  cursor: pointer;
  line-height: 12px;
}

.multiSelect {
  cursor: pointer;
  line-height: 10px;
}
.multiSelect .p-placeholder {
  color: #595959 !important;
}
.multiSelect .p-multiselect {
  width: 124px !important;
}

.p-overlaypanel {
  position: absolute !important;
}

.p-multiselect-item {
  font-size: 10px !important;
  line-height: 12px !important;
  padding: 0px 0 !important;
}

.p-inputtext {
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: Montserrat !important;
  color: #000000;
}

.apply-filter-text {
  color: "#003DA5" !important;
}

.duration {
  color: #9a9898;
  background-color: #ffffff !important;
  width: 38px;
  height: 20px;
  border-color: #9a9898;
  border-radius: 4px;
  padding: 0px;
  font-weight: 400;
  font-size: 10px;
}

.helpNeeded {
  color: #ffffff;
  background-color: #01d309 !important;
  width: 48px;
  height: 20px;
  border: none;
  border-radius: 4px;
  padding: 0px;
  font-weight: 500;
  font-size: 12px;
}

.iconsStyle {
  cursor: default;
  margin-right: 3.3px;
  width: 13.33px;
  height: 13.33px;
}

.iconsTextStyle {
  color: #03a000;
  font-size: 10px;
  line-height: 12px;
  cursor: default;
}

.iconInprogress {
  color: #003da5 !important;
}

.iconLock {
  color: #595959 !important;
}

.iconAwaiting {
  color: #d37302 !important;
}

.iconRejected {
  color: #ff0000 !important;
}

.TaskStyles {
  color: #003da5;
  cursor: pointer;
}

.projectplan-calender .p-calendar {
  display: block;
}
.projectplan-calender .p-inputtext {
  border-radius: 4px !important;
  height: 32px;
}

.textAlignTreeTable .p-treetable-thead .cursorMove {
  cursor: move;
}
.textAlignTreeTable .p-treetable-thead .fontBoldcolor {
  color: #145392;
}
.textAlignTreeTable .p-treetable-tbody .fontBoldcolor {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
}

.projectPlanCompoButtons {
  height: 32px;
  width: auto;
  border-radius: 20px !important;
  padding: 10px 18px 10px 18px;
  margin-right: 23px;
  font-weight: 500;
  font-size: 12px;
  color: #003da5;
  line-height: 12px;
}

.projectPlanCompoButtonsColor {
  color: #ffffff;
  background-color: #00a3e0;
}

.projectPlanCompoButtonsColor1 {
  color: #ffffff;
  background-color: #003da5;
}

.overrideIcon {
  cursor: pointer;
  margin-left: 5px;
}

.accordion.projectPlanAccordian {
  margin: 0px;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header {
  background-color: #f7f7f7;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header .accordion-button {
  background-color: #f7f7f7 !important;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header {
  position: relative !important;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header > button {
  height: 25px;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header > button::after {
  position: absolute !important;
  margin-left: 110px;
}

.columnHeader {
  width: max-content;
}

.approveDesignDialog {
  width: 722px;
  height: 429px;
  border-radius: 20px;
}
.approveDesignDialog .p-dialog-content {
  overflow-y: hidden !important;
}

.columnBorder {
  background-color: #fafcff;
  font-size: 14px;
  font-weight: 500;
  line-height: 13px;
  color: #595959;
}

.columnBorder > div {
  margin-top: 5px;
  border-right: 0.5px solid #acacac;
  text-align: center;
  min-width: fit-content;
}

.columnBorder > div:last-child {
  border-right: none;
}

.columnBorder1 > div {
  margin: 10px 0 0 0;
  text-align: center;
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
}
.columnBorder1 > div select {
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
  font-weight: 400 !important;
}
.columnBorder1 > div div > label {
  font-size: 10px !important;
}

.columnBorder2 > div {
  margin-bottom: 20px;
  text-align: center;
  color: #595959;
}
.columnBorder2 > div select {
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
  font-weight: 400 !important;
}
.columnBorder2 > div div > label {
  font-size: 10px !important;
}

.submitButton {
  padding-top: 10px !important;
  text-align: right;
}
.submitButton button {
  font-weight: 500 !important;
  height: 32px !important;
  width: 93px !important;
}

.submitButton > button {
  background-color: #003da5 !important;
  width: 93px;
  height: 40px;
  color: #fff !important;
  font-size: 12px;
  border-radius: 20px;
  padding: 10px 24px;
}

.dropdownStyles {
  width: inherit;
  border-color: #acacac;
  padding: 4px 5px;
  border-radius: 8px;
}

.textAlignLeft {
  text-align: left;
}

.visuallyHidden {
  visibility: hidden;
}

.approveDesignDiv {
  position: relative;
  border: 0.5px solid #acacac;
  height: 144px;
  width: 377.5px;
  margin-left: 142px;
  border-radius: 5px;
  padding: 13px 15px;
}

.approveDesignDiv::before,
.approveDesignDiv::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 160px;
  border: 11px solid transparent;
  border-bottom-color: #dddddd;
}

.approveDesignDiv::after {
  left: 161px;
  border: 10px solid transparent;
  border-bottom-color: #ffffff;
}

.approveDesignDivHeading {
  font-weight: 600;
  font-size: 14px;
  line-height: 13.44px;
  color: #595959;
  line-height: 33px !important;
}

.approveDesignDivData {
  font-weight: 400;
  font-size: 14px;
  line-height: 13.44px;
  color: #595959;
}

.approveDesignDiv2Data {
  margin-top: 11px;
}

div[disabled] {
  pointer-events: none;
  opacity: 0.7;
}

.p-autocomplete-dd .p-autocomplete-dropdown,
.p-autocomplete-dd .p-autocomplete-dropdown:hover {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border: none;
}

.p-calendar {
  position: relative;
  display: inline-flex;
  max-width: 100%;
  height: 32px !important;
}

.p-autocomplete {
  border: 1px solid #ced4da !important;
  border-radius: 6px;
  width: 100%;
  height: 32px !important;
}
.p-autocomplete.p-autocomplete-dd .p-autocomplete-input {
  border: 0;
}
.p-autocomplete.p-autocomplete-dd .p-autocomplete-input:enabled:focus {
  box-shadow: none;
}

.helpneeded_done {
  color: #03a000;
}

.helpneeded_inprocess {
  color: #ff0000;
}

.form-select {
  cursor: pointer;
}

.form-select[disabled] {
  cursor: default;
}

.p-treetable .p-treetable-tbody > tr > td {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/FilesAndFolder/index.scss"],"names":[],"mappings":"AAaE;EACE,YAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;;AAiBA;EACE,aAAA;AAdF;;AAiBA;;EAEE,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAdF;;AAiBA;;EAEE,WAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAkBA;EACE,eAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;AAfF;;AAkBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfF;;AAkBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,8BAAA;EACA,sBAAA;AAfF;;AAiBA;EACE,8BAAA;EACA,gBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,QAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAdF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,2BAAA;AAfF;;AAmBA;EACE,YAAA;EACA,gBAAA;AAhBF;AAkBE;EACE,yBAAA;EACA,gBAAA;AAhBJ;AAkBI;EACE,YAAA;EACA,WAAA;AAhBN;AAkBM;EACE,YAAA;EACA,gBAAA;AAhBR;AAmBQ;EAEE,kBAAA;EACA,yBAAA;AAlBV;AAuBI;EAIE,0BAAA;AAxBN;AA4BE;EACE,gBAAA;EACA,WArIO;AA2GX;AAyCE;EACE,gBAnJY;AA4GhB;AAsDE;;;;EAIE,kBAAA;AApDJ;AAyDE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAvDJ;AA+DE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA7DJ;AAgEE;EACE,sBAAA;EACA,0BAAA;AA9DJ;AAgEI;EACE,cAAA;AA9DN;;AAmEA;EACE,gBAAA;AAhEF;;AAmEA;EACE,WAAA;AAhEF;;AAmEA;EACE,cAAA;AAhEF;;AAmEA;EACE,gBArNc;EAsNd,eAAA;EACA,iBAAA;AAhEF;;AAoEA;EACE,YAAA;EAEA,eAAA;AAlEF;;AAwEA;EACE,aAAA;EACA,8BAAA;AArEF;;AAwEA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AArEF;;AAwEA;EACE,eAAA;AArEF;;AAwEA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AArEF;;AAwEA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;AArEF;;AAwEA;EACE,eAAA;EACA,iBAAA;AArEF;AAuEE;EAEE,yBAAA;AAtEJ;AAyEE;EACE,uBAAA;AAvEJ;;AA4EA;EACE,6BAAA;AAzEF;;AA4EA;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;EACA,cAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA6EA;EACE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA1EF;;AAgFA;EACE,yBAAA;AA7EF;;AAgFA;EACE,yBAAA;AA7EF;;AAgFA;EACE,yBAAA;AA7EF;;AAgFA;EACE,yBAAA;AA7EF;;AAgFA;EACE,cAAA;EACA,eAAA;AA7EF;;AAiFE;EACE,cAAA;AA9EJ;AAiFE;EACE,6BAAA;EACA,YAAA;AA/EJ;;AAgGI;EACE,YAAA;AA7FN;AAgGI;EACE,cAAA;AA9FN;AAmGI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAjGN;;AAsGA;EACE,YAAA;EAEA,WAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;EACA,iBAAA;AArGF;;AAwGA;EACE,cAAA;EACA,yBAAA;AArGF;;AAwGA;EACE,cAAA;EACA,yBAAA;AArGF;;AAwGA;EACE,eAAA;EACA,gBAAA;AArGF;;AAyGA;EACE,WAAA;AAtGF;AAwGE;EACE,yBAAA;AAtGJ;AAwGI;EACE,oCAAA;AAtGN;AA0GE;EACE,6BAAA;AAxGJ;AA2GE;EACE,YAAA;AAzGJ;AA4GE;EACE,6BAAA;EACA,kBAAA;AA1GJ;;AA8GA;EAEE,kBAAA;AA5GF;;AAgHA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AA7GF;AA+GE;EACE,6BAAA;AA7GJ;;AAiHA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA9GF;;AAiHA;EACE,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,sBAAA;AA9GF;;AAiHA;EACE,kBAAA;AA9GF;;AAiHA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;AA9GF;AAiHE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AA/GJ;AAkHE;EACE,0BAAA;AAhHJ;;AAoHA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;AAjHF;AAoHE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AAlHJ;AAqHE;EACE,0BAAA;AAnHJ;;AAuHA;EACE,4BAAA;EACA,iBAAA;AApHF;AAsHE;EACE,2BAAA;EACA,uBAAA;EACA,sBAAA;AApHJ;;AAwHA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AArHF;;AAwHA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AArHF;;AAwHA;EACE,gBAAA;AArHF;;AAwHA;EACE,kBAAA;AArHF;;AAwHA;EACE,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AArHF;;AAwHA;;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,4BAAA;AArHF;;AAwHA;EACE,WAAA;EACA,8BAAA;EACA,4BAAA;AArHF;;AAwHA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,4BAAA;AArHF;;AAwHA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AArHF;;AAwHA;EACE,gBAAA;AArHF;;AAwHA;EACE,oBAAA;EACA,YAAA;AArHF;;AAwHA;;EAEE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;AArHF;;AAwHA;EAEE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;AAtHF;;AAyHA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAtHF;AAwHE;EACE,SAAA;AAtHJ;AAwHI;EACE,gBAAA;AAtHN;;AA4IA;EACE,cAAA;AAzIF;;AA4IA;EACE,cAAA;AAzIF;;AA4IA;EACE,eAAA;AAzIF;;AA4IA;EACE,eAAA;AAzIF;;AA2IA;EACE,gBAAA;AAxIF","sourcesContent":["$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n\n.jobListTable {\n  // .textAlignTreeTable>div>.p-treetable-table>.p-treetable-tbody>tr>td {\n  //   min-width: 80px !important;\n  // }\n\n  // .textAlignTreeTable>div>.p-treetable-table>.p-treetable-thead>tr>th {\n  //   min-width: 80px !important;\n  // }\n\n  .task-field-width {\n    width: 350px;\n  }\n\n  .non-task-width {\n    width: 200px;\n  }\n}\n\n.d-n {\n  display: none;\n}\n\n.version,\n.action {\n  width: 100%;\n  display: block;\n  cursor: pointer;\n  text-align: center;\n}\n\n.owner,\n.date {\n  width: 100%;\n  display: block;\n  cursor: default;\n  // text-align: center;\n}\n\n.download_icon {\n  cursor: pointer;\n  padding-right: 15px;\n}\n\n.view_pdf_icon {\n  cursor: pointer;\n}\n\n.upload-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n}\n\n.action-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wrap-free-text {\n  white-space: normal !important;\n  word-break: break-word;\n}\n.nowrap-free-text {\n  white-space: nowrap !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.myProjectAnddAllProjectList.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler {\n  width: 0;\n  height: 0;\n  padding: 7px;\n  border-radius: 0%;\n  border: 1px solid black;\n}\n\n.p-confirm-popup {\n  position: absolute;\n  top: 12% !important;\n  left: 0% !important;\n}\n\n// Datepicker for ProjectSetUp component Style Start\n.p-datepicker table td {\n  padding: 0.2px !important;\n}\n\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n// Datepicker for ProjectSetUp component Style End\n.myProjectAnddAllProjectList {\n  height: 100%;\n  overflow: hidden;\n\n  .p-treetable {\n    height: calc(100% - 90px);\n    overflow: hidden;\n\n    > .p-treetable-wrapper {\n      height: 100%;\n      width: 100%;\n\n      .p-treetable-scrollable-view {\n        height: 100%;\n        overflow: hidden;\n        // width: auto !important;\n\n        .p-treetable-scrollable-body {\n          // overflow: auto;\n          position: relative;\n          height: calc(100% - 46px);\n        }\n      }\n    }\n\n    &.searchWithTreeTable\n      > .p-treetable-wrapper\n      .p-treetable-scrollable-view\n      .p-treetable-scrollable-body {\n      height: calc(100% - 100px);\n    }\n  }\n\n  .p-datatable > .p-datatable-wrapper {\n    overflow: scroll;\n    width: $width100;\n  }\n\n  // .p-datatable-table {\n  //   line-height: 15px;\n  // }\n\n  // .p-column-title {\n  //   font-weight: $fontWeight500;\n  // }\n\n  // .p-column-title > div {\n  //   display: flex;\n  // }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  // th:after,\n  // td:after {\n  //   content: '';\n  //   display: block;\n  //   height: 100%;\n  //   width: 0.8px;\n  //   background-color: #acacac;\n  //   position: absolute;\n  //   top: 0%;\n  //   right: 0;\n  // }\n\n  td,\n  table .p-datatable .p-datatable-tbody > tr > td,\n  th,\n  tr {\n    position: relative;\n    // border: 0 !important;\n    // height: 40px;\n  }\n\n  .input-duration > input {\n    max-width: 70px;\n    border-radius: 5px;\n    text-align: center;\n    height: 25px;\n  }\n\n  // .form-control:focus,\n  // .p-inputwrapper-filled {\n  //   border: none;\n  // }\n\n  .task-link {\n    color: #003da5;\n    cursor: pointer;\n    line-height: 15px;\n    line-break: anywhere;\n  }\n\n  table .p-inputtext {\n    width: 100% !important;\n    font-size: 12px !important;\n\n    &.p-autocomplete-input {\n      padding: 0 5px;\n    }\n  }\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.p-checkbox {\n  margin: 8px;\n}\n\n.p-checkbox-checked + label {\n  color: #003da5;\n}\n\n.ml-2 {\n  font-weight: $fontWeight400;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n// Filter and Save buttons disabled\nimg[disabled] {\n  opacity: 0.5;\n  // pointer-events: none;\n  cursor: no-drop;\n}\n\n// ProjectList Styles End\n\n// ConfirmationPopUp Styles Start\n.clearAllFilterMainDiv {\n  display: flex;\n  padding: 10.56px 22px 22px 2px;\n}\n\n.clearAllFilterDiv {\n  line-height: 12px;\n  justify-items: end;\n  display: flex;\n  position: absolute;\n  right: 22px;\n  top: 18px;\n}\n\n.clearAllFilter {\n  cursor: pointer;\n}\n\n.clearAllFilterIcon {\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n}\n\n.sortAndFrozen {\n  padding: 0 22px 22px 2px;\n  cursor: pointer;\n  line-height: 12px;\n}\n\n.multiSelect {\n  cursor: pointer;\n  line-height: 10px;\n\n  .p-placeholder {\n    // font-size: 8px !important;\n    color: #595959 !important;\n  }\n\n  .p-multiselect {\n    width: 124px !important;\n    // height: 16px !important;\n  }\n}\n\n.p-overlaypanel {\n  position: absolute !important;\n}\n\n.p-multiselect-item {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  padding: 0px 0 !important;\n}\n\n.p-inputtext {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-family: Montserrat !important;\n  color: #000000;\n}\n\n.apply-filter-text {\n  color: \"#003DA5\" !important;\n}\n\n// ProjectPlan Styles Start\n.duration {\n  color: #9a9898;\n  background-color: #ffffff !important;\n  width: 38px;\n  height: 20px;\n  border-color: #9a9898;\n  border-radius: 4px;\n  padding: 0px;\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.helpNeeded {\n  color: #ffffff;\n  background-color: #01d309 !important;\n  width: 48px;\n  height: 20px;\n  border: none;\n  border-radius: 4px;\n  padding: 0px;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.iconsStyle {\n  cursor: default;\n  margin-right: 3.3px;\n  width: 13.33px;\n  height: 13.33px;\n}\n\n.iconsTextStyle {\n  color: #03a000;\n  font-size: 10px;\n  line-height: 12px;\n  cursor: default;\n  // margin-right: 3.3px;\n  // width: 13.33px;\n  // height: 13.33px;\n}\n\n.iconInprogress {\n  color: #003da5 !important;\n}\n\n.iconLock {\n  color: #595959 !important;\n}\n\n.iconAwaiting {\n  color: #d37302 !important;\n}\n\n.iconRejected {\n  color: #ff0000 !important;\n}\n\n.TaskStyles {\n  color: #003da5;\n  cursor: pointer;\n}\n\n.projectplan-calender {\n  .p-calendar {\n    display: block;\n  }\n\n  .p-inputtext {\n    border-radius: 4px !important;\n    height: 32px;\n  }\n\n  // .p-button.p-button-icon-only {\n  //   color: #adadad !important;\n  //   background: #fff !important;\n  //   border-radius: 6px;\n  //   height: 30px;\n  //   border: 0;\n  //   position: absolute;\n  //   right: 1px;\n  //   top: 1px;\n  // }\n}\n\n.textAlignTreeTable {\n  .p-treetable-thead {\n    .cursorMove {\n      cursor: move;\n    }\n\n    .fontBoldcolor {\n      color: #145392;\n    }\n  }\n\n  .p-treetable-tbody {\n    .fontBoldcolor {\n      font-weight: bold;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n}\n\n.projectPlanCompoButtons {\n  height: 32px;\n  // width: 86px;\n  width: auto;\n  border-radius: 20px !important;\n  padding: 10px 18px 10px 18px;\n  margin-right: 23px;\n  font-weight: 500;\n  font-size: 12px;\n  // background-color: #acacac !important;\n  color: #003da5;\n  line-height: 12px;\n}\n\n.projectPlanCompoButtonsColor {\n  color: #ffffff;\n  background-color: #00a3e0;\n}\n\n.projectPlanCompoButtonsColor1 {\n  color: #ffffff;\n  background-color: #003da5;\n}\n\n.overrideIcon {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n// ProjectPlan Styles End\n.accordion.projectPlanAccordian {\n  margin: 0px;\n\n  .accordion-item > .accordion-header {\n    background-color: #f7f7f7;\n\n    .accordion-button {\n      background-color: #f7f7f7 !important;\n    }\n  }\n\n  .accordion-item > .accordion-header {\n    position: relative !important;\n  }\n\n  .accordion-item > .accordion-header > button {\n    height: 25px;\n  }\n\n  .accordion-item > .accordion-header > button::after {\n    position: absolute !important;\n    margin-left: 110px;\n  }\n}\n\n.columnHeader {\n  // display: flex;\n  width: max-content;\n}\n\n// APrrove Dialog Styles Start\n.approveDesignDialog {\n  width: 722px;\n  height: 429px;\n  border-radius: 20px;\n\n  .p-dialog-content {\n    overflow-y: hidden !important;\n  }\n}\n\n.columnBorder {\n  background-color: #fafcff;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 13px;\n  color: #595959;\n}\n\n.columnBorder > div {\n  margin-top: 5px;\n  border-right: 0.5px solid #acacac;\n  text-align: center;\n  min-width: fit-content;\n}\n\n.columnBorder > div:last-child {\n  border-right: none;\n}\n\n.columnBorder1 > div {\n  margin: 10px 0 0 0;\n  text-align: center;\n  color: #595959;\n  font-size: 10px !important;\n  line-height: 10px;\n\n  // min-width: fit-content;\n  select {\n    color: #595959;\n    font-size: 10px !important;\n    line-height: 10px;\n    font-weight: 400 !important;\n  }\n\n  div > label {\n    font-size: 10px !important;\n  }\n}\n\n.columnBorder2 > div {\n  margin-bottom: 20px;\n  text-align: center;\n  color: #595959;\n\n  // min-width: fit-content;\n  select {\n    color: #595959;\n    font-size: 10px !important;\n    line-height: 10px;\n    font-weight: 400 !important;\n  }\n\n  div > label {\n    font-size: 10px !important;\n  }\n}\n\n.submitButton {\n  padding-top: 10px !important;\n  text-align: right;\n\n  button {\n    font-weight: 500 !important;\n    height: 32px !important;\n    width: 93px !important;\n  }\n}\n\n.submitButton > button {\n  background-color: #003da5 !important;\n  width: 93px;\n  height: 40px;\n  color: #fff !important;\n  font-size: 12px;\n  border-radius: 20px;\n  padding: 10px 24px;\n}\n\n.dropdownStyles {\n  width: inherit;\n  border-color: #acacac;\n  padding: 4px 5px;\n  border-radius: 8px;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n.visuallyHidden {\n  visibility: hidden;\n}\n\n.approveDesignDiv {\n  position: relative;\n  border: 0.5px solid #acacac;\n  height: 144px;\n  width: 377.5px;\n  margin-left: 142px;\n  border-radius: 5px;\n  padding: 13px 15px;\n}\n\n.approveDesignDiv::before,\n.approveDesignDiv::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 160px;\n  border: 11px solid transparent;\n  border-bottom-color: #dddddd;\n}\n\n.approveDesignDiv::after {\n  left: 161px;\n  border: 10px solid transparent;\n  border-bottom-color: #ffffff;\n}\n\n.approveDesignDivHeading {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 13.44px;\n  color: #595959;\n  line-height: 33px !important;\n}\n\n.approveDesignDivData {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 13.44px;\n  color: #595959;\n}\n\n.approveDesignDiv2Data {\n  margin-top: 11px;\n}\n\ndiv[disabled] {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.p-autocomplete-dd .p-autocomplete-dropdown,\n.p-autocomplete-dd .p-autocomplete-dropdown:hover {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border: none;\n}\n\n.p-calendar {\n  //border: 1px solid #ced4da !important;\n  position: relative;\n  display: inline-flex;\n  max-width: 100%;\n  height: 32px !important;\n}\n\n.p-autocomplete {\n  border: 1px solid #ced4da !important;\n  border-radius: 6px;\n  width: 100%;\n  height: 32px !important;\n\n  &.p-autocomplete-dd .p-autocomplete-input {\n    border: 0;\n\n    &:enabled:focus {\n      box-shadow: none;\n    }\n  }\n}\n\n// .p-treetable .p-treetable-tbody>tr {\n//   background: #ffffff;\n//   color: #495057;\n//   transition: box-shadow 0.2s;\n//   height: 35px !important;\n//   /* overflow: auto; */\n// }\n\n// .p-treetable-resizable .p-treetable-thead>tr>th,\n// .p-treetable-resizable .p-treetable-tfoot>tr>td,\n// .p-treetable-resizable .p-treetable-tbody>tr>td {\n//   overflow: hidden;\n//   border: 1px solid #acacac;\n//   white-space: nowrap;\n// }\n\n// APrrove Dialog Styles End\n.helpneeded_done {\n  color: #03a000;\n}\n\n.helpneeded_inprocess {\n  color: #ff0000;\n}\n\n.form-select {\n  cursor: pointer;\n}\n\n.form-select[disabled] {\n  cursor: default;\n}\n.p-treetable .p-treetable-tbody > tr > td{\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
